export default "__VITE_PUBLIC_ASSET__37203cbf__"